export const T = {
  en_GB: {
    sustainabilityConflictBadge: "Sustainability mismatch",
    sustainabilityConflictTooltip:
      "This product does not match the client's sustainability preferences.",
    replacesBadge: (product: string) => `Replaces ${product}`,
    replacesTooltip: (product: string) =>
      `This product took over weight from ${product}: the client is not eligible for it, or it does not match the client's sustainability preferences.`,
    partiallyReplacesBadge: (product: string) => `Partially replaces ${product}`,
    partiallyReplacesTooltip: (product: string) =>
      `This product took over part of the weight of ${product}, which does not match the client's sustainability preferences. ${product} keeps the rest.`,
    replacesAlternatives: (products: string) => `Other good candidates: ${products}.`,
    unsuitableBadge: "Not suitable, no replacement",
    unsuitableTooltip:
      "The client is not eligible for this product and no eligible product shares an asset class with it.",
    preferenceBadge: (preference: string) => `Preference: ${preference}`,
    preferenceTooltip: (preference: string) =>
      `This product received the share added for the client's preference ${preference}.`,
    preferenceAlternatives: (products: string) => `Other eligible products: ${products}.`,
  },
  nb_NO: {
    sustainabilityConflictBadge: "Bærekraftsavvik",
    sustainabilityConflictTooltip:
      "Dette produktet samsvarer ikke med klientens bærekraftspreferanser.",
    replacesBadge: (product: string) => `Erstatter ${product}`,
    replacesTooltip: (product: string) =>
      `Dette produktet overtok vekt fra ${product}: klienten er ikke kvalifisert for det, eller det samsvarer ikke med klientens bærekraftspreferanser.`,
    partiallyReplacesBadge: (product: string) => `Erstatter delvis ${product}`,
    partiallyReplacesTooltip: (product: string) =>
      `Dette produktet overtok en del av vekten fra ${product}, som ikke samsvarer med klientens bærekraftspreferanser. ${product} beholder resten.`,
    replacesAlternatives: (products: string) => `Andre gode kandidater: ${products}.`,
    unsuitableBadge: "Ikke egnet, ingen erstatning",
    unsuitableTooltip:
      "Klienten er ikke kvalifisert for dette produktet, og ingen kvalifiserte produkter deler en aktivaklasse med det.",
    preferenceBadge: (preference: string) => `Preferanse: ${preference}`,
    preferenceTooltip: (preference: string) =>
      `Dette produktet fikk andelen som ble lagt til for klientens preferanse ${preference}.`,
    preferenceAlternatives: (products: string) => `Andre kvalifiserte produkter: ${products}.`,
  },
} as const;
